import { logger } from "./shared/logger";
import { Resolve } from "./transport/response";

export function onCancel(callback: (() => void) | undefined): void {
	window._cancel = callback ?? onCancel.default;
}

onCancel.default = () => {
	logger.debug("cancel: default called");
	return void Resolve.Error("Cancelled", {
		message: "The request was cancelled before it could be processed.",
	});
};

/**
 * Registered via {@link onCancel} on screens where a `Cancel` request from the
 * host must not resolve the default "Cancelled" result: the approved and
 * declined response screens, and while the terminal is processing (it can't
 * honour a cancel then). Error and cancelled screens keep the default, which
 * resolves the same "Cancelled" their close control would.
 * Only the host's request is dropped — the screen's own close/cancel controls
 * are separate handlers and keep working.
 */
onCancel.ignoreExternal = () => {
	logger.warn("cancel: external ignored");
};
